import { useEffect } from "react"

const widgetScriptId = "z2-messaging-widget-script"
const WebWidgetMessaging = () => {
  useEffect(() => {
    // Clean up any existing widget scripts
    const existingScript = document.getElementById(widgetScriptId)
    if (existingScript) {
      existingScript.remove()
    }

    const script = document.createElement("script")
    script.id = widgetScriptId
    script.async = true

    // Use different z2-messaging-widget scripts based on environment
    if (window.location.hostname === "developer.zendesk.com") {
      // Production z2-messaging-widget
      script.src =
        "https://static.zdassets.com/z2-sunco-widget/z2-messaging-widget.js"
    } else {
      // Staging z2-messaging-widget
      script.src =
        "https://static-staging.zdassets.com/z2-sunco-widget/z2-messaging-widget.js"
    }

    script.onerror = () => {
      // Widget failed to load
      console.warn("Z2 Messaging Widget failed to load")
    }

    script.onload = () => {
      // Widget loaded successfully
      if (typeof window.Z2MessagingWidget === "function") {
        // eslint-disable-next-line no-underscore-dangle
        window.__z2MessagingWidgetRef = new window.Z2MessagingWidget({
          inProduct: false,
          inShoppingCart: false
        })

        // Wait for widget to be fully ready
        window.Z2MessagingWidget.ready()
          .then(() => {
            console.log("Z2MessagingWidget is ready - window.zE is available")
          })
          .catch(error => {
            console.error("Error initializing Z2MessagingWidget:", error)
          })
      } else {
        console.warn("Z2MessagingWidget is not available on window")
      }
    }

    document.body.appendChild(script)

    // Cleanup function to remove script when component unmounts
    return () => {
      const scriptToRemove = document.getElementById(widgetScriptId)
      if (scriptToRemove) {
        scriptToRemove.remove()
      }
    }
  }, [])

  return null
}

export default WebWidgetMessaging
